<div class="access-request" *ngIf="canload">
  <header>
    <div class="logo" [routerLink]="['./']">
      <img src="assets/img/accesshublogo.png" alt="accesshublogo">
    </div>
  </header>

  <div class="content">
    <div class="info-block">
      <div class="header">
        <div class="image">
          <img src="assets/img/accesshublogo.png" alt="accesshublogo">
        </div>
        <div class="title">User Access Request</div>
        <div class="subtitle">You are currently not a member of this platform. Please use this form to request access.</div>
      </div>
      <div class="request-form">
        <div class="sign-in">
          <div class="form-container MB0">
            <h6 class="label">Select which you are a part of: <span class="required"> *</span></h6>

            <div class="custom-control custom-radio">
              <input (change)="updateJurisdiction($event)" type="radio" value="Global" class="custom-control-input" id="Global" name="jurisdictionOptions" checked mdbInput>
              <label class="custom-control-label" for="Global">Global</label>
            </div>

            <div class="custom-control custom-radio">
              <input (change)="updateJurisdiction($event)" value="Area" type="radio" class="custom-control-input" id="Area" name="jurisdictionOptions" mdbInput>
              <label class="custom-control-label" for="Area">Area</label>
            </div>

            <div class="custom-control custom-radio">
              <input (change)="updateJurisdiction($event)" value="Affiliate" type="radio" class="custom-control-input" id="Affiliate" name="jurisdictionOptions" mdbInput>
              <label class="custom-control-label" for="Affiliate">Affiliate</label>
            </div>
          </div>

          <div class="form-container" [hidden]="this.requestDetails.jurisdiction === 'Global'">
            <div [hidden]="this.requestDetails.jurisdiction !== 'Area'">
              <h6 class="label">Which Area ?</h6>
              <div class="input">
                <input type="text" (keyup)="validate()" [(ngModel)]="this.requestDetails.area" placeholder="" class="">
              </div>
            </div>
            <div [hidden]="this.requestDetails.jurisdiction !== 'Affiliate'">
              <h6 class="label">Which Country ?</h6>
              <div class="input">
                <input type="text" (keyup)="validate()" [(ngModel)]="this.requestDetails.country" placeholder="" class="">
              </div>
            </div>
          </div>

          <div class="custom-control custom-switch right-position MT10">
            <input type="checkbox" (change)="validate(); this.requestDetails.functionDescription = ''" [(ngModel)]="this.requestDetails.marketAccessFunction" class="custom-control-input pull-right" id="customSwitch1" checked>
            <label class="custom-control-label" for="customSwitch1">Is your current role part of the Market Access function?</label>
            <span class="switch-value">
              <ng-container *ngIf="this.requestDetails.marketAccessFunction">Yes</ng-container>
              <ng-container *ngIf="!this.requestDetails.marketAccessFunction">No</ng-container>
            </span>
          </div>

          <div class="form-container" [hidden]="this.requestDetails.marketAccessFunction">
            <h6 class="label">What Function are you a part of?</h6>
            <div class="input">
              <input type="text" (keyup)="validate()" [(ngModel)]="this.requestDetails.functionDescription" placeholder="" class="">
            </div>
          </div>

          <div class="custom-control custom-switch right-position MT14">
            <input type="checkbox" (change)="validate()" [(ngModel)]="this.requestDetails.fieldFacing" class="custom-control-input pull-right" id="customSwitch2">
            <label class="custom-control-label" for="customSwitch2">Are you in a field-facing role?</label>
            <span class="switch-value">
              <ng-container *ngIf="this.requestDetails.fieldFacing">Yes</ng-container>
              <ng-container *ngIf="!this.requestDetails.fieldFacing">No</ng-container>
            </span>
          </div>

          <div class="buttons-row">
            <button [disabled]="!buttonSubmitEnabled" (click)="submit()">Submit</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="footer">
    <span class="copyright">Copyright © 2021 AbbVie Inc. North Chicago, Illinois, U.S.A.</span>
    <div>
      <a href="mailto:AccessHub@abbvie.com"><i></i>Questions, Comments or Feedback?</a>
    </div>
  </div>
</div>

